import React from "react";
import { MapPin, Gauge, RotateCcw, Tag, Sparkles, Share2, Check, X, ImageDown } from "lucide-react";
import VehicleSelector from "./VehicleSelector";

export default function CalculatorInputs({
  distance, setDistance,
  consumption, handleConsumptionChange,
  returnTrip, setReturnTrip,
  tripName, setTripName,
  saving, loadingPrice, liveResult,
  handleSaveToHistory, handleShareTrip, handleOpenShareCard,
  shareCopied, sharedTrip, setSharedTrip,
  user, selectedVehicle, setSelectedVehicle,
}) {
  return (
    <div className="sf-inputs-section">
      {/* Vehicle Selector (login only) */}
      <VehicleSelector
        user={user}
        selectedVehicle={selectedVehicle}
        onSelectVehicle={setSelectedVehicle}
        onConsumptionChange={handleConsumptionChange}
      />

      <div className="space-y-5 mb-6">
        <div>
          <label className="sf-label"><MapPin className="w-4 h-4" />DISTANCE (KM)</label>
          <input type="number" inputMode="decimal" value={distance} onChange={(e) => setDistance(e.target.value)} placeholder="Route or manual" className="sf-input" data-testid="calculator-distance-input" min="0" step="any" />
        </div>
        <div>
          <label className="sf-label"><Gauge className="w-4 h-4" />FUEL CONSUMPTION (L/100KM)</label>
          <input type="number" inputMode="decimal" value={consumption} onChange={(e) => handleConsumptionChange(e.target.value)} placeholder="e.g. 8" className="sf-input" data-testid="calculator-consumption-input" min="0" step="any" />
          <p className="text-xs text-[#666666] mt-2 font-mono break-words">
            {selectedVehicle
              ? `Using ${selectedVehicle.name} (${selectedVehicle.consumption_l_per_100km} L/100km)`
              : "Typical: 6-8 cars · 10-15 SUVs/trucks"}
          </p>
        </div>
      </div>

      {/* Return Trip */}
      <div className="flex flex-wrap items-center gap-4 mb-5">
        <label className="sf-toggle" data-testid="return-trip-toggle">
          <input type="checkbox" checked={returnTrip} onChange={(e) => setReturnTrip(e.target.checked)} className="sr-only" />
          <div className={`sf-toggle-track ${returnTrip ? 'active' : ''}`}><div className="sf-toggle-thumb" /></div>
          <span className="flex items-center gap-1.5 text-sm text-[#1A1A1A] font-['Manrope']"><RotateCcw className="w-3.5 h-3.5" />Return trip</span>
          {returnTrip && <span className="sf-badge-green">x2</span>}
        </label>
      </div>

      {/* Trip Name */}
      <div className="mb-5">
        <div className="flex items-center gap-2">
          <Tag className="w-4 h-4 text-[#666666]" />
          <input type="text" value={tripName} onChange={(e) => setTripName(e.target.value)} placeholder="Name this trip (optional)"
            className="sf-input flex-1 text-sm" data-testid="trip-name-input" />
        </div>
      </div>

      {/* Save & Share Buttons */}
      <div className="flex gap-3">
        <button onClick={handleSaveToHistory} disabled={saving || loadingPrice || !liveResult} className="sf-primary-btn flex-1" data-testid="calculator-submit-button">
          {saving ? (<><div className="sf-spinner" />SAVING...</>) : (<><Sparkles className="w-5 h-5" />SAVE TO HISTORY</>)}
        </button>
        <button onClick={handleOpenShareCard} disabled={!liveResult} className="sf-share-btn" data-testid="share-card-open-btn" title="Export trip card image">
          <ImageDown className="w-5 h-5" />
        </button>
        <button onClick={handleShareTrip} disabled={!liveResult} className="sf-share-btn" data-testid="share-trip-btn" title="Copy share link">
          {shareCopied ? <Check className="w-5 h-5" /> : <Share2 className="w-5 h-5" />}
        </button>
      </div>
      {sharedTrip && (
        <div className="sf-shared-badge" data-testid="shared-trip-badge">
          <Share2 className="w-3.5 h-3.5" />
          <span>Shared trip loaded{sharedTrip.origin && sharedTrip.destination ? `: ${sharedTrip.origin} → ${sharedTrip.destination}` : ''}</span>
          <button onClick={() => setSharedTrip(null)} className="ml-auto"><X className="w-3.5 h-3.5" /></button>
        </div>
      )}
    </div>
  );
}
